export default {"src":"/_next/static/media/deliveryprogress.8945d7e2.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};